import { Box, Typography } from '@mui/material';
import { SurveyCalculationsPanel } from '../../../presentation-components/surveys/builder/survey-calculations-panel';
import { sortItemsByPage } from '../../../../shared/utils/survey-rules/group-pages';
import { SharedSetBanner } from './shared-set-banner';
import { SurveyHubTabProps } from '../survey-hub-page';

export const SurveyCalculationsTab = ({ survey, reload, isPartnerLocked, goToTab }: SurveyHubTabProps) => {
  const group = survey.surveyQuestionGroup;
  const groupId = survey.surveyQuestionGroupId;

  if (!groupId || !group) {
    return (
      <Box>
        <Typography variant='body2' color='text.secondary'>
          Add questions first: calculations are built from the survey&apos;s answers.
        </Typography>
        <Typography
          variant='body2'
          color='primary'
          sx={{ mt: 1, cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => goToTab('questions')}
        >
          Go to Questions
        </Typography>
      </Box>
    );
  }

  const items = sortItemsByPage(group.surveyQuestionGroupItems ?? []);
  const rules = group.surveyQuestionGroupEmissionRules ?? [];

  return (
    <Box>
      <SharedSetBanner groupId={groupId} />
      <SurveyCalculationsPanel
        groupId={groupId}
        groupItems={items}
        rules={rules}
        locked={isPartnerLocked}
        onChanged={reload}
      />
    </Box>
  );
};
